import {
  calculateUnseenMessageCount,
  createRoom as createRoomState,
  insertRoomUser as insertRoomUserState,
  resetUnreadMessageCount,
  selectRoom as selectRoomState,
  selectRoomClear as selectRoomClearState,
  setRoomList,
  updateLatestMessage,
} from "@/store/reducers/room";
import { setConnectedUsers } from "@/store/reducers/user";
import useJwt from "@/utils/jwt/useJwt";
import { handleLogout } from "@/store/actions/auth";

// ** Get all Data
export const getRoomList = () => {
  return async (dispatch) => {
    useJwt
      .getRoomList()
      .then((res) => {
        if (res.data.ResponseCode === 0) {
          const data = res.data.ResponseResult;
          const connectedUsers = [];

          for (const room of data) {
            for (const user of room.room_users) {
              connectedUsers.push(user);
            }
          }

          dispatch(setConnectedUsers(connectedUsers));
          dispatch(setRoomList(data));
        } else {
          console.log(res.data.ResponseCode);
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(handleLogout());
        }
      });
  };
};

// ** create room
export const createRoom = (user) => createRoomState(user);

export const insertRoomUser = (roomUser) => insertRoomUserState(roomUser);

// ** Select Chat
export const selectRoom = (room) => selectRoomState(room);

export const resetUnreadCount = (payload) => resetUnreadMessageCount(payload);

export const calculateUnSeenCount = () => calculateUnseenMessageCount();

export const updateRoomLastMessage = (messages) => {
  return (dispatch, getState) => {
    const currentUserId = getState().auth.userData?.id ?? useJwt.getUserID();
    dispatch(updateLatestMessage({ messages, currentUserId }));
  };
};

export const selectRoomClear = () => selectRoomClearState();
